import { InspectorProps } from "@app/components/WidgetStudio/Inspector/contracts/InspectorProps";
import { useGetStoryGroupList } from "@shortsworks/user-api";
import { LoaderCircle } from "lucide-react";
import { Button } from "@shortsworks/ui";
import { Children, useState, useEffect } from "react";

export interface GroupInspectorProps extends InspectorProps {}

export const GroupInspector = ({
  onValueChange,
  defaultFormValues,
}: GroupInspectorProps) => {
  const [groupIds, setGroupIds] = useState<string[]>(
    defaultFormValues?.groupId?.split(",") ?? [],
  );
  const { data: storyGroupListData, isSuccess: isSuccessGetStoryGroupList } =
    useGetStoryGroupList();

  const handleClickResetSelectedGroups = () => {
    return setGroupIds([]);
  };

  // 멀티 선택이 되도록 관리
  const handleClickSelectGroupId = (selectedGroupId: string) => () => {
    if (groupIds.includes(selectedGroupId)) {
      return setGroupIds(
        groupIds.filter((groupId) => groupId !== selectedGroupId),
      );
    } else {
      return setGroupIds([...groupIds, selectedGroupId]);
    }
  };

  useEffect(() => {
    return onValueChange({ groupIds: groupIds });
  }, [groupIds]);

  if (!isSuccessGetStoryGroupList) {
    return (
        <LoaderCircle className="w-full h-6 mr-2 animate-spin" />
    );
  }

  const activatedStoryGroupList = storyGroupListData.data.filter(
    (group) => !group.isDisabled,
  );

  return (
    <div className="flex flex-col gap-2">
      <Button
        onClick={handleClickResetSelectedGroups}
        variant={groupIds.length === 0 ? "outline" : "ghost"}
      >
        전체
      </Button>
      {Children.toArray(
        activatedStoryGroupList.map((group) => {
          return (
            <Button
              onClick={handleClickSelectGroupId(group.id)}
              variant={groupIds.includes(group.id) ? "outline" : "ghost"}
            >
              {group.name}
            </Button>
          );
        }),
      )}
    </div>
  );
};
